export function FontBackground (pEditor)
{
  let prevBackColor;
  
  
  const getCurrentBackColor = () =>
  {
    let backColor;

    if (BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevBackColor != null)
    {
      return prevBackColor;
    }

    backColor = pEditor.style.helpers.getCurrentStyleInRange('backgroundColor');

    if (!(backColor && backColor.replace(/\s+/g, '').toLowerCase() !== 'rgba(0,0,0,0)'))
    {
      backColor = '';
    }

    prevBackColor = backColor;
    return backColor;
  };
  
  
  this.openBackColorDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', getCurrentBackColor() || '');
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'setBackColor');
    }
  };


  const setBackColor = (pButton) =>
  {
    const reTags = /B|STRONG|I|EM|U|SUP|SUB|STRIKE|FONT|A/;

    let i,
        pParameters,
        backColorIds,
        elements,
        backColor,
        savedBackColor,
        newTag;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();
    }

    if (pParameters && pParameters.selectedStyleId != null)
    {
      backColorIds = pParameters.selectedStyleId;
    }

    pEditor.closeDropdown(pButton);

    if (backColorIds != null)
    {
      pEditor.range.stopCheckSelection();

      if (backColorIds.trim() === '')
      {
        backColorIds = 'transparent';
      }
      else if (backColorIds.toLowerCase().indexOf('transparent') === -1)
      {
        backColorIds = '#' + backColorIds;
      }

      if (!BEditor.browser.isIE)
      {
        if (BEditor.browser.isWebKit)
        {
          elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

          for (i = elements.length; i--;)
          {
            backColor = elements[i].style.backgroundColor;

            if (backColor)
            {
              elements[i].setAttribute('data-wafixwebkitbackcolor', backColor.replace(/\s+/g, ''));
            }
          }
        }

        pEditor.iFrameDoc.execCommand('styleWithCSS', false, true);
        pEditor.iFrameDoc.execCommand('hilitecolor', false, backColorIds);

        if (BEditor.browser.isWebKit)
        {
          if (pEditor.bodyStyles.background.backgroundColor !== BEditor.styleHelpers.getElementStyle(pEditor.iFrameDoc.body, 'backgroundColor'))
          {
            pEditor.iFrameDoc.body.style.backgroundColor = pEditor.bodyStyles.background.backgroundColor;
          }

          elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

          for (i = elements.length; i--;)
          {
            backColor = elements[i].style.backgroundColor;

            if (backColor)
            {
              backColor = backColor.replace(/\s+/g, '');
              savedBackColor = elements[i].getAttribute('data-wafixwebkitbackcolor');

              if (backColor === 'rgba(0,0,0,0)' && (!savedBackColor || savedBackColor !== 'rgba(0,0,0,0)'))
              {
                if (savedBackColor)
                {
                  elements[i].style.backgroundColor = savedBackColor;
                }
                else
                {
                  elements[i].style.backgroundColor = '';

                  if (elements[i].getAttribute('style') === '')
                  {
                    elements[i].removeAttribute('style');
                  }
                }
              }
              else if (!savedBackColor && reTags.test(elements[i].nodeName))
              {
                newTag = pEditor.iFrameDoc.createElement('SPAN');
                newTag.style.backgroundColor = elements[i].style.backgroundColor;
                elements[i].style.backgroundColor = '';

                if (elements[i].nodeName === 'A')
                {
                  newTag.innerHTML = elements[i].innerHTML;
                  elements[i].innerHTML = '';
                  elements[i].appendChild(newTag);
                }
                else
                {
                  newTag.innerHTML = elements[i].outerHTML;
                  elements[i].parentNode.replaceChild(newTag, elements[i]);
                }
              }
            }
          }

          elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wafixwebkitbackcolor]');

          for (i = elements.length; i--;)
          {
            elements[i].removeAttribute('data-wafixwebkitbackcolor');
          }
        }
      }
      else
      {
        pEditor.iFrameDoc.execCommand('backcolor', false, backColorIds);
      }

      pEditor.range.restoreBookmark();
    }
    else
    {
      return false;
    }
  };


  this.getCurrentBackColor = getCurrentBackColor;
  this.setBackColor = setBackColor;
}